import { z } from 'zod'

export const favoriteReportsResponseSchema = z.object({
  favorite_reports: z.array(z.string()).nullable(),
})

export type FavoriteReportsResponse = z.infer<typeof favoriteReportsResponseSchema>

export const updateFavoriteReportResponseSchema = z.object({
  message: z.string(),
})

export type UpdateFavoriteReportResponse = z.infer<typeof updateFavoriteReportResponseSchema>

export const updateFavoriteReportRequestSchema = z.object({
  is_favorite: z.boolean(),
})

export type UpdateFavoriteReportRequest = z.infer<typeof updateFavoriteReportRequestSchema>
